import { useState, useEffect } from "react";
import Footer from '../../components/footer';
import BlogsCard from '../../../src/components/blog/components/blogs-cards';
import LatestBlog from '../../../src/components/blog/components/latest-blog';
import BlogHero from "../../components/blog-hero/BlogHero";
import SkeletonComponent from "../../utils/skeleton-component/SkeletonComponent";
import { useGetBlogsData } from "../../api/blog.api";
import { toast } from "react-toastify";
import { upperCaseFirst } from "upper-case-first";










export default function PostIndex({
  pagePath
}) {

  // This components is the component for the blog home





  const [title, setTitle] = useState(`Eraconneckt | ${upperCaseFirst(pagePath)}`);

  const [blogData, setBlogData] = useState([]);

  const {
    status,
    data,
    error
  } = useGetBlogsData();

  useEffect(() => {
    if (status === "success") {
      setBlogData(data?.data)
    }
  }, [data?.data, status])

  status === "error" && toast.error(error?.response?.data?.error);



  useEffect(() => {
    // This will run when the page first loads and whenever the title changes

    setTitle(`Eraconneckt | ${upperCaseFirst(pagePath)}`);

    document.title = title;
  }, [pagePath, title]);



  return (
    <>

      <BlogHero
        slug={upperCaseFirst(pagePath)}
      />

      {/* Latest Blog */}


      <>
        {status === "pending" ? (<SkeletonComponent count={7} />) :

          <LatestBlog
            data={blogData && blogData}
          />


        }

      </>

      <>
        {status === "pending" ? (<SkeletonComponent count={7} />) :
          <BlogsCard
            data={blogData}
            pagePath={pagePath}
          />

        }
      </>

      <Footer />
    </>
  )
}